var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgChevronRight = function SvgChevronRight(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "#5C5C5C",
    viewBox: "0 0 14 25"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M.622 1.298A2.14 2.14 0 0 0 0 2.814a2.16 2.16 0 0 0 .622 1.515l8.249 8.34-8.25 8.34a2.15 2.15 0 0 0-.62 1.515 2.16 2.16 0 0 0 .62 1.515 2.12 2.12 0 0 0 1.5.628 2.1 2.1 0 0 0 1.499-.628l9.758-9.865A2.14 2.14 0 0 0 14 12.658a2.16 2.16 0 0 0-.622-1.515L3.62 1.277C2.812.46 1.45.46.622 1.298"
  })));
};
export default SvgChevronRight;